import { PagePagination } from '@components/core-ui/Pagination';

import { usePageContext } from '../../../../providers/PageProvider';

export const Pagination = () => {
  const { users, page, setPage, pageSize, setPageSize } = usePageContext();

  return (
    <PagePagination
      totalItemsCount={users.count ?? 0}
      page={page}
      onPageChange={setPage}
      pageSize={pageSize}
      setPageSize={setPageSize}
    />
  );
};
